<template>
    <div class="container">
        <!-- 面包屑导航 -->
        <!-- 面包屑导航 -->
        <div class="breadcrumb">
            <el-breadcrumb separator="">
                <el-breadcrumb-item :to="{ path: '/sysText' }">
                    <div class="div1">系统文件</div>
                </el-breadcrumb-item>
                <el-breadcrumb-item>
                    <div class="div2">编辑系统文件</div>
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <!-- 面包屑导航 -->
        <div class="content" style="padding-bottom:40px;">
            <h2>{{ breadcrumbTitle }}</h2>
            <div>
                <el-form :model="cuponForm" :rules="cuponRules" ref="cuponForm" label-width="150px" class="info-form">
                    <el-form-item label="标题" prop="title">
                        <el-input style="width:450px" v-model="cuponForm.title" placeholder="请输入标题" maxlength="14"
                            show-word-limit clearable></el-input>
                    </el-form-item>
                    <el-form-item label="内容" prop="content" class="brand-id">
                        <quill-editor v-model="cuponForm.content" ref="myQuillEditor" :options="editorOption"
                            class="editor"></quill-editor>
                        <div class="bottom" style="display: none">
                            <el-upload class="centerImg" :action="' '" list-type="picture-card" :auto-upload="false"
                                :on-change="handleAvatarChangeIcon" ref="uploadicon">
                            </el-upload>
                        </div>
                    </el-form-item>
                </el-form>
            </div>
            <div class="content bottom-but">
                <el-button type="warning" @click="$router.go(-1)">返回</el-button>
                <el-button type="primary" @click="submitFn">提交</el-button>
            </div>
        </div>
    </div>
</template>
<script>
import navbar from '@/components/navbar.vue'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import { quillEditor } from 'vue-quill-editor'
import Quill from 'quill'
import imageResize from 'quill-image-resize-module' // 引用
import { ImageDrop } from 'quill-image-drop-module'
Quill.register('modules/imageDrop', ImageDrop)
Quill.register('modules/imageResize', imageResize) // 注册
import mixinsGoodsEdit from '../../goods/mixins/mixinsGoodsEdit.js'
import mixinsGoodsEditQuill from '../../goods/mixins/mixinsGoodsEditQuill.js'
export default {
    components: { navbar, quillEditor },
    mixins: [mixinsGoodsEdit, mixinsGoodsEditQuill],
    data() {
        return {
            cuponForm: {
                title: '',//优惠券名称
                content: '',//优惠券面值
                id: null
            },
            cuponRules: {
                title: [
                    { required: true, message: '请输入标题', trigger: 'blur' },
                    // { min: 1, max: 14, message: '长度在 1 到 14 个字符', trigger: 'blur' }
                ],
                content: [
                    { required: true, message: '请输入内容', trigger: 'blur' }
                ]

            },
            breadcrumbTitle: '系统文件'
        }
    },
    created() {
        let cid = this.$route.query.id || null;
        this.cuponForm.id = cid;
        if(cid){
            this.getData()
        }
    },
    methods: {
        getData() {
            this.axios.get('/sys/sysText/get?id='+this.cuponForm.id)
            .then(res=>{
                console.log(res)
                if(res.code == 0){
                    this.cuponForm.title = res.data.title
                    this.cuponForm.content = res.data.content
                }
            })
        },
        submitFn() {
            console.log(this.cuponForm)
            if(this.cuponForm.title == ''){
                this.$message.warning('请输入标题')
                return
            }
            if(this.cuponForm.content == ''){
                this.$message.warning('请输入内容')
                return
            }
            this.axios.post('/sys/sysText/save',this.cuponForm)
            .then(res=>{
                console.log(res)
                if(res.code == 0){
                    this.$message.success('保存成功')
                    this.$router.go(-1)
                }
            })
        },


        //数组去重
        arrDistinctByProp(arr, prop) {
            if (prop) {
                return arr.filter(function (item, index, self) {
                    return self.findIndex(el => el[prop] == item[prop]) === index
                })
            } else {
                return Array.from(new Set(arr));
            }

        }
    }
}

</script>
<style scoped lang="scss">
.div1 {
    margin-left: -16px;
    background: url(../../../assets/breadcrumb2.png);
    width: 120px;
    height: 30px;
    text-align: center;
    line-height: 30px;
    color: #2d7edf;
}

.div2 {
    margin-left: -16px;
    background: url(../../../assets/breadcrumb1.png);
    width: 120px;
    height: 30px;
    text-align: center;
    line-height: 30px;
    color: #fff;
}

::v-deep .el-form-item__content {
    margin-bottom: 10px;
}

.bottom-but {
    margin-top: 60px;
    margin-bottom: 40px;
    // text-align: center;
    margin-left: 40px;

    .el-button {
        width: 220px;
        height: 48px;
        border-radius: 4px;
        font-size: 18px;
    }

    .el-button+.el-button {
        margin-left: 32px;
    }
}

.cascabox {
    width: 60%;
    margin-top: 10px;
    position: relative;
}

.cascabtnbox {
    position: absolute;
    right: 50px;
    bottom: 10px;
    z-index: 33;
}

::v-deep .el-cascader-menu:nth-child(3) {
    flex: 1;
}

::v-deep .el-cascader-menu:nth-child(3) .el-cascader-menu__list {
    display: flex;
    flex-wrap: wrap;
    padding-bottom: 50px;
}

.selected {
    // width: 80%;
    padding: 14px 18px;
    box-sizing: border-box;
    border: 1px dashed #E0E0E0;
    display: flex;
    align-items: center;
}

.selectedbox {
    display: flex;
    // width: 90%;
    flex-wrap: wrap;
    color: #4168E7;
    font-size: 14px;
}

.selected-item {
    margin-left: 16px;
    // margin-bottom: 10px;
    background-color: #F0F3FD;
    position: relative;
    padding: 3px 14px;
    position: relative;
    border-radius: 4px;
    line-height: 28px;
}

.labeliconbox {
    cursor: pointer;
    position: absolute;
    right: -6px;
    top: -6px;
    cursor: pointer;
    background-color: white;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    display: flex;
    align-items: center;
}

.labelicon {
    color: #4168E7;
    font-size: 16px;
}

.table-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.table-top-left {
    display: flex;
    align-items: center;
}

.goods-table {
    width: 100%;
}

::v-deep .el-image {
    width: 72px;
    height: 56px;
}

.tag-status {
    display: flex;
    align-items: center;
    justify-content: center;
}

.circle {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    margin-right: 4px;
}

.table-incl {
    width: 65%;
    padding: 24px;
    box-sizing: border-box;
    background-color: #E3EDFF;
}

.primary-button {
    width: 120px;
    height: 36px;
    background: #4168E7;
    border-radius: 4px;
    line-height: 36px;
    text-align: center;
    color: white;
    font-size: 16px;
    cursor: pointer;
    display: inline-block;
}

.primary-mini {
    width: 68px;
    height: 32px;
    background: #E3EDFF;
    border-radius: 4px;
    line-height: 32rpx;
    text-align: center;
    font-size: 16px;
    color: #4168E7;
    cursor: pointer;
    display: inline-block;
    margin-right: 20px;
}

.primary-plain {
    width: 120px;
    height: 36px;
    background: #FFFFFF;
    border: 1px solid #4168E7;
    border-radius: 4px;
    line-height: 36px;
    color: #4168E7;
    text-align: center;
    margin-right: 16px;
    cursor: pointer;
    display: inline-block;
}

.primary-gray {
    width: 120px;
    height: 36px;
    border: 1px solid #D9D9D9;
    border-radius: 4px;
    margin-right: 16px;
    cursor: pointer;
    display: inline-block;
    line-height: 36px;
    text-align: center;
    color: #999999;
}
</style>